module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "centered add-webinar"
  }, [_c('a', {
    staticClass: "button is-info",
    on: {
      "click": _vm.handleAddWebinar
    }
  }, [_vm._v("+ Добавить темы")])]), _vm._v(" "), _c('div', {
    staticClass: "webinars"
  }, _vm._l((_vm.webinars), function(webinar) {
    return _c('div', {
      staticClass: "webinar-wrapper"
    }, [_c('Webinar', {
      key: webinar.id,
      attrs: {
        "webinar": webinar
      },
      on: {
        "webinar-saved": _vm.reloadWebinars
      }
    })], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11a36664"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/Themes.vue
// module id = 899
// module chunks = 0